import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import { CoreContext } from './context/index.js';
import { logImgLoadErrorToRelic } from './utils/logToRelic.js';

const getLabel = (labels, locale) => {
    if (!labels) {
        return '';
    }
    const label = labels.find(labelItem => labelItem.lang === locale);
    return label ? label.value : labels[0].value;
};
const Gallery = ({ item }) => {
    const { asPath } = useRouter();
    const data = item === null || item === void 0 ? void 0 : item.data;
    if (!data)
        return null;
    const { data: { locale }, } = useContext(CoreContext);
    return (React.createElement("div", { className: "base-info-variant-gallery" },
        React.createElement("div", { className: "gallery-container" }, data.items.map((itemVal, index) => (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("div", { key: index, className: "item" },
            React.createElement("div", { className: "title" }, getLabel(itemVal.labels, locale)),
            React.createElement("div", { className: "image-wrapper" },
                React.createElement("img", { src: itemVal.url, alt: getLabel(itemVal.labels, locale), onError: () => logImgLoadErrorToRelic(asPath, itemVal.url) })))))),
        React.createElement("div", { className: "info-text" }, getLabel(data.infoText, locale))));
};

export { Gallery as G, getLabel as g };
//# sourceMappingURL=Gallery-lGbUPTvY.js.map
